import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import styles from "./newsite.module.css";
import { ArrowRight } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getEntityByProperty } from "../../../utils/Filters";
import toast from "react-hot-toast";
import { LoadingButton } from "@mui/lab";
import Loading from "../../../Components/Loading/Loading";
import { useSelector } from "react-redux";

function NewSite() {
  const theme = useTheme();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  // Data Fields
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [users, setUsers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]);
  const role = useSelector((state) => state.auth.role.roleName);
  const fetchData = useCallback(async () => {
    setInitialLoading(true);
    try {
      const paymentmethods = await axios.get(
        `${process.env.REACT_APP_API_URL}/paymentmethod/`,
        {
          withCredentials: true,
        }
      );
      let users = [];
      if (role === "SuperAdmin") {
        users = await axios.get(`${process.env.REACT_APP_API_URL}/user/`, {
          withCredentials: true,
        });
      } else {
        users = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/employees`,
          {
            withCredentials: true,
          }
        );
      }

      setInitialLoading(false);
      setAvailableUsers(users.data);
      setAvailablePaymentMethods(paymentmethods.data);
    } catch (error) {
      setInitialLoading(false);
      toast.error(error.message || error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const siteTypes = ["ثابت", "متحرك"];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleUsersChange = (e) => {
    setUsers(e.target.value);
  };
  const handlePaymentChange = (e) => {
    let payments = e.target.value;
    if (type === "متحرك") {
      if (payments.length > 0) {
        setPayments([payments[payments.length - 1]] || []);
      } else {
        setPayments([]);
      }
    } else {
      setPayments(payments);
    }
  };
  function handleSubmit() {
    setLoading(true);
    const newErrors = {};

    // Validation checks
    if (!name.trim()) newErrors.name = "الإسم مطلوب.";
    if (!type.trim()) newErrors.type = "النوع مطلوب.";
    if (payments.length === 0)
      newErrors.payments = "مطلوب ادخال طريقة دفع واحدة على الأقل.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }
    let usersIds;
    if (users.length > 0) {
      const listOfUsers = users.map((user) => {
        return getEntityByProperty("username", availableUsers, user);
      });
      usersIds = listOfUsers.map((user) => user.id);
    }
    let paymentMethodsId;
    if (payments.length > 0) {
      const listOfPaymentMethods = payments.map((p) => {
        return getEntityByProperty("name", availablePaymentMethods, p);
      });
      paymentMethodsId = listOfPaymentMethods.map((p) => p.id);
    }

    const newSite = {
      name: name,
      type: type,
      usersId: usersIds,
      paymentMethodsId: paymentMethodsId,
    };
    setErrors({});

    if (newSite) {
      axios
        .post(`${process.env.REACT_APP_API_URL}/sites/`, newSite, {
          withCredentials: true,
        })
        .then((res) => {
          setLoading(false);
          navigate("/app/sites/");
          toast.success("تم إنشاء الموقع بنجاح!");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(
            err.response?.data?.error ||
              "An error occurred while creating the user"
          );
        });
    }
  }

  const navigate = useNavigate();
  return initialLoading ? (
    <Loading />
  ) : (
    <div>
      <div className={styles.form}>
        <div className={styles.container}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              onClick={() => navigate(-1)}
              variant="contained"
              sx={{
                width: "48px",
                height: "48px",
                padding: 0,
                margin: 0,
                minWidth: "auto",
                marginRight: "12px",
              }}
            >
              <ArrowRight size={24} />
            </Button>
            <Typography
              variant="h4"
              color={theme.palette.neutral[900]}
              fontWeight={700}
            >
              إضافة موقع جديد
            </Typography>
          </div>
          <div className={styles.basicDetails}>
            <div className={styles.formSection}>
              <Typography
                variant="h5"
                color={theme.palette.neutral[800]}
                fontWeight={600}
                marginBottom={2}
              >
                معلومات الموقع
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={(2, 3)}>
                {/* View Quantity Field */}
                <FormControl fullWidth sx={{ minWidth: "250px" }}>
                  <TextField
                    fullWidth
                    label="إسم الموقع"
                    type="text"
                    value={name}
                    error={!!errors.name}
                    helperText={errors.name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </FormControl>

                {/* View Type Field */}
                <FormControl
                  fullWidth
                  sx={{ minWidth: "250px" }}
                  error={!!errors.type}
                >
                  <InputLabel id="role-label">نوع الموقع</InputLabel>
                  <Select
                    fullWidth
                    labelId="role-label"
                    label="نوع الموقع"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    {siteTypes.map((t, index) => (
                      <MenuItem key={index} value={t}>
                        {t}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.type}</FormHelperText>
                </FormControl>

                <FormControl
                  sx={{ flex: "1 1 100%", minWidth: "250px" }}
                  error={!!errors.payments}
                >
                  <InputLabel id="demo-multiple-chip-label">
                    طرق الدفع المتاحة في الموقع
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={payments}
                    onChange={handlePaymentChange}
                    input={
                      <OutlinedInput
                        id="select-multiple-chip"
                        label="طرق الدفع المتاحة في الموقع"
                      />
                    }
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {availablePaymentMethods?.map((p) => (
                      <MenuItem key={p.id} value={p.name}>
                        {p.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.payments}</FormHelperText>
                </FormControl>

                {/* Assign Users To site */}
                <FormControl sx={{ flex: "1 1 45%", minWidth: "250px" }}>
                  <InputLabel id="demo-multiple-chip-label">
                    الموظّفون في الموقع
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={users}
                    onChange={handleUsersChange}
                    input={
                      <OutlinedInput
                        id="select-multiple-chip"
                        label="الموظّفون في الموقع"
                      />
                    }
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {availableUsers.map((user) => (
                      <MenuItem key={user.id} value={user.username}>
                        {user.username}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    يمكنك إضافة الموظّفون في الموقع لاحقاً.
                  </FormHelperText>
                </FormControl>
              </Box>
            </div>
          </div>
          <LoadingButton
            variant="contained"
            color="primary"
            loading={loading}
            sx={{ fontSize: "20px" }}
            fullWidth
            onClick={handleSubmit}
          >
            إضافة
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}

export default NewSite;
